module.exports = __webpack_public_path__ + "img/991.3fed98be.png";